// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"b5213402","498":"8fae0f01","703":"cbbd6fdb"}[chunkId] + ".chunk.js";
};